/* eslint-disable */
/* tslint:disable */

import {
	BusinessProcessPatternLogEntry,
	CategorizationLogEntry,
	CategorizationStepFourTwoLogEntry,
	ConstructionObjectLogEntry,
	DocumentLogEntry,
	DocumentPatternLogEntry,
	EmployeeLogEntry,
	GenericDictionaryLogEntry,
	HistoryEntry,
	OkvedDictionaryLogEntry,
	OrganizationLogEntry,
	OrganizationSimpleResponse,
	RoleLogEntry,
	ThreatLogEntry,
	UserLogEntry,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

class Audit<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary Список организаций, доступных для просмотра лога категорирования
	 * @request GET:/audit/organizations/list
	 * @secure
	 */
	organizationsListList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/** категория записей */
			category:
				| "ACTIVITY_AREA"
				| "BUSINESS_PROCESS_PATTERN"
				| "CONSTRUCTION_OBJECT"
				| "DOCUMENT"
				| "EMPLOYEE"
				| "INAPPLICABILITY_REASON"
				| "OBJECT_STATUS"
				| "OBJECT_TYPE"
				| "OKVED"
				| "ORGANIZATION"
				| "ORGANIZATION_DOCUMENT_PATTERN"
				| "ORGANIZATION_MARKER"
				| "PERSON_STATUS"
				| "OWNERSHIP_TYPE"
				| "ROLE"
				| "SIGNIFICANCE_CRITERIA"
				| "THREAT"
				| "THREAT_CONSEQUENCE"
				| "THREAT_MODEL_TEMPLATE"
				| "USER"
				| "CATEGORIZATION_STEP_ONE"
				| "CATEGORIZATION_STEP_TWO_ONE"
				| "CATEGORIZATION_STEP_TWO_TWO"
				| "CATEGORIZATION_STEP_THREE"
				| "CATEGORIZATION_STEP_FOUR_ONE"
				| "CATEGORIZATION_STEP_FOUR_TWO"
				| "CATEGORIZATION_STEP_FIVE"
				| "CATEGORIZATION_STEP_SIX"
				| "CATEGORIZATION_STEP_SEVEN";
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/audit/organizations/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения объектов капитального строительства
	 * @request GET:/audit/construction-object
	 * @secure
	 */
	constructionObjectList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ConstructionObjectLogEntry[], void>({
			path: `/audit/construction-object`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения документов организации
	 * @request GET:/audit/document
	 * @secure
	 */
	documentList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<DocumentLogEntry[], void>({
			path: `/audit/document`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника сотрудников
	 * @request GET:/audit/employee
	 * @secure
	 */
	employeeList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			organization?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<EmployeeLogEntry[], void>({
			path: `/audit/employee`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения организационной структуры
	 * @request GET:/audit/organization
	 * @secure
	 */
	organizationList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationLogEntry[], void>({
			path: `/audit/organization`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения статусов категорирования
	 * @request GET:/audit/organization/{organization}/categorization-status
	 * @secure
	 */
	organizationCategorizationStatusDetail = (
		organization: number,
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<HistoryEntry[], void>({
			path: `/audit/organization/${organization}/categorization-status`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения системных ролей
	 * @request GET:/audit/role
	 * @secure
	 */
	roleList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<RoleLogEntry[], void>({
			path: `/audit/role`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника пользователей
	 * @request GET:/audit/user
	 * @secure
	 */
	userList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<UserLogEntry[], void>({
			path: `/audit/user`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника сфер деятельности
	 * @request GET:/audit/dictionary/activity-area
	 * @secure
	 */
	dictionaryActivityAreaList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/activity-area`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника шаблонов реестра бизнес-процессов
	 * @request GET:/audit/dictionary/business-process-pattern
	 * @secure
	 */
	dictionaryBusinessProcessPatternList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternLogEntry[], void>({
			path: `/audit/dictionary/business-process-pattern`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника последствий реализации угроз
	 * @request GET:/audit/dictionary/threat-consequence
	 * @secure
	 */
	dictionaryThreatConsequenceList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/threat-consequence`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника причин неприменимости показателей критериев значимости
	 * @request GET:/audit/dictionary/inapplicability-reason
	 * @secure
	 */
	dictionaryInapplicabilityReasonList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/inapplicability-reason`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника статусов объектов
	 * @request GET:/audit/dictionary/object-status
	 * @secure
	 */
	dictionaryObjectStatusList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/object-status`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника типов объектов
	 * @request GET:/audit/dictionary/object-type
	 * @secure
	 */
	dictionaryObjectTypeList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/object-type`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника кодов ОКВЭД
	 * @request GET:/audit/dictionary/okved
	 * @secure
	 */
	dictionaryOkvedList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OkvedDictionaryLogEntry[], void>({
			path: `/audit/dictionary/okved`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника системных шаблонов документов
	 * @request GET:/audit/dictionary/organization-document-pattern
	 * @secure
	 */
	dictionaryOrganizationDocumentPatternList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<DocumentPatternLogEntry[], void>({
			path: `/audit/dictionary/organization-document-pattern`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника пользовательских шаблонов документов
	 * @request GET:/audit/dictionary/organization-document-pattern/user
	 * @secure
	 */
	dictionaryOrganizationDocumentPatternUserList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			organization?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<DocumentPatternLogEntry[], void>({
			path: `/audit/dictionary/organization-document-pattern/user`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника маркеров организаций
	 * @request GET:/audit/dictionary/organization-marker
	 * @secure
	 */
	dictionaryOrganizationMarkerList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/organization-marker`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника статусов сотрудников
	 * @request GET:/audit/dictionary/person-status
	 * @secure
	 */
	dictionaryPersonStatusList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/person-status`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника видов владения
	 * @request GET:/audit/dictionary/ownership-type
	 * @secure
	 */
	dictionaryOwnershipTypeList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/ownership-type`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника показателей критериев значимости
	 * @request GET:/audit/dictionary/significance-criteria
	 * @secure
	 */
	dictionarySignificanceCriteriaList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/significance-criteria`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения справочника угроз
	 * @request GET:/audit/dictionary/threat
	 * @secure
	 */
	dictionaryThreatList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatLogEntry[], void>({
			path: `/audit/dictionary/threat`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История изменения шаблонов моделей угроз
	 * @request GET:/audit/dictionary/threat-model-template
	 * @secure
	 */
	dictionaryThreatModelTemplateList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<GenericDictionaryLogEntry[], void>({
			path: `/audit/dictionary/threat-model-template`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на первом шаге категорирования
	 * @request GET:/audit/categorization/1
	 * @secure
	 */
	categorization1List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/1`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на шаге категорирования 2.1
	 * @request GET:/audit/categorization/2/1
	 * @secure
	 */
	categorization21List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/2/1`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на шаге категорирования 2.2
	 * @request GET:/audit/categorization/2/2
	 * @secure
	 */
	categorization22List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/2/2`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на третьем шаге категорирования
	 * @request GET:/audit/categorization/3
	 * @secure
	 */
	categorization3List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/3`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на шаге категорирования 4.1
	 * @request GET:/audit/categorization/4/1
	 * @secure
	 */
	categorization41List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/4/1`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на шаге категорирования 4.2
	 * @request GET:/audit/categorization/4/2
	 * @secure
	 */
	categorization42List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationStepFourTwoLogEntry[], void>({
			path: `/audit/categorization/4/2`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на пятом шаге категорирования
	 * @request GET:/audit/categorization/5
	 * @secure
	 */
	categorization5List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/5`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на шестом шаге категорирования
	 * @request GET:/audit/categorization/6
	 * @secure
	 */
	categorization6List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/6`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Аудит
	 * @summary История действий на седьмом шаге категорирования
	 * @request GET:/audit/categorization/7
	 * @secure
	 */
	categorization7List = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/**
			 * пользователь
			 * @format int32
			 */
			user?: number;
			/**
			 * организация
			 * @format int32
			 */
			organization: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CategorizationLogEntry[], void>({
			path: `/audit/categorization/7`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
}
export const auditAPI = new Audit();
